/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import AppRouterSwitch from "./AppRouterSwitch";
import { useAppSnackbar } from "./Basis/Components/AppSnackbarContext";

export default function AppRouter() {
    const history = useHistory();
    const appSnackbarContext = useAppSnackbar();
    useEffect(() => history.listen(appSnackbarContext.clearOnRouteChange));
    return <AppRouterSwitch />;
}
